var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDrop = function SvgDrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.61 16.83c-.98.93-2.26 1.44-3.61 1.44-.11 0-.21-.01-.32-.01a.75.75 0 0 1-.7-.8c.02-.41.37-.72.79-.7 1.05.07 2.05-.3 2.81-1.02.38-.36.68-.77.88-1.24q.165-.39.24-.81c.07-.4.46-.68.87-.6.41.07.68.46.61.87-.08.391-.19.77-.35 1.13-.28.66-.69 1.24-1.22 1.74M7.91 1.14A.98.98 0 0 0 7 .5c-.41 0-.76.26-.91.64C4.42 5.43.98 7.18.17 11.18c-.88 4.27 2.06 8.57 6.41 8.82a7 7 0 0 0 7.43-7c0-5.43-4.2-6.97-6.1-11.86",
    clipRule: "evenodd"
  })));
};
export default SvgDrop;